<!--
  未使用
 -->
<template>
  <div v-if="!SsPsShow">
    <table>
      <tr>
        <th>{{ $t('lang.particulars.long') }}</th>
        <td v-if="list.deviceLongitude">
          {{ list.deviceLongitude }}
          <span v-if="list.deviceLocType == 2" class="Gps-Information">{{ $t('lang.particulars.GPSrequire') }}</span>
        </td>
        <td v-else>N/A</td>
        <th>{{ $t('lang.particulars.lat') }}</th>
        <td v-if="list.deviceLatitude">
          {{ list.deviceLatitude }}
          <span v-if="list.deviceLocType == 2" class="Gps-Information">{{ $t('lang.particulars.GPSrequire') }}</span>
        </td>
        <td v-else>N/A</td>
      </tr>
    </table>
    <div v-if="list.deviceLongitude && list.deviceLatitude">
      <!-- 配置高德地图 -->
      <device-long-lat :long="list.deviceLongitude" :lan="list.deviceLatitude" ref="map"
        v-if="this.Map === 'zh-CN' && !SsPsShow" />
      <!-- 配置谷歌地图 -->
      <googlemap :long="list.deviceLongitude" :lan="list.deviceLatitude" ref="map"
        v-if="this.Map === 'en-US' && !SsPsShow" />
      <div style="height:30px" v-if="!SsPsShow"></div>
      <div class="Set-GPS" v-if="!SsPsShow">
        <el-button type="success" size="mini" @click="GetLonLan"
          v-if="list.deviceLocType != 2 && Permission.indexOf(194) != -1">{{ $t('lang.particulars.si_modify')
          }}</el-button>
        <el-button type="primary" size="mini" @click="ResetMap"
          v-if="list.deviceLocType != 2 && Permission.indexOf(194) != -1">{{ $t('lang.particulars.reset_type')
          }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import deviceLongLat from "../deviceLongLat";
import googlemap from "../googlemap";
import {
  showDeviceDetail,
  addDeviceN2n,
  delDeviceN2n,
  updateGps,
  updateDevice
} from "@/api/particulars";
export default {
  props: ['list', 'SsPsShow', 'Permission'],
  components: {
    deviceLongLat,
    googlemap,
  },
  methods: {
    //获取地图组件传来的经纬度
    GetLonLan() {
      let map = this.$refs.map.GetMap();
      this.$confirm(
        `${this.$t("lang.particulars.message14")}${map.long}${this.$t(
          "lang.particulars.message17"
        )}${map.lan}?`,
        this.$t("lang.particulars.message3"),
        {
          confirmButtonText: this.$t("lang.particulars.message4"),
          cancelButtonText: this.$t("lang.particulars.message5"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          updateGps(this.deviceId, map.long, map.lan).then(res => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: this.$t("lang.particulars.message15"),
                type: "success"
              });
              this.$emit('showDeviceDetail')
              // this.showDeviceDetail();
            } else {
              this.$message({
                showClose: true,
                message: this.$t("lang.particulars.message16"),
                type: "warning"
              });
            }
          });
        })
        .catch(() => { });
    },
    //重置地图坐标
    ResetMap() {
      this.$refs.map.ResetLatLng();
    },
  },
}
</script>